import { customFormFromJSON, CustomFormRecord } from "common/records/CustomForm";
import { RootActions, RootState } from "common/reducers";
import {
  CustomFormActions,
  RECEIVE_CUSTOM_FORM,
  RECEIVE_CUSTOM_FORMS,
  RESET_CUSTOM_FORM,
  UPDATE_CUSTOM_FORM_RJSF,
} from "common/reducers/customForm.actions";
import { receive, reset } from "common/reducers/Utils";
import { fromJS, Map, Record } from "immutable";
import { cloneDeep } from "lodash";

export const CustomFormStateRecord = Record({
  byId: Map<string | -1, CustomFormRecord>(),
  lastSavedById: Map<string | -1, CustomFormRecord>(),
});

export const customFormsInitialState = CustomFormStateRecord();

export type CustomFormState = typeof customFormsInitialState;

export const model = "customForms";
export const customFormsReducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, customFormsInitialState);
  }

  switch (action.type) {
    case RECEIVE_CUSTOM_FORM: {
      return receive(state, model, customFormFromJSON(action.payload));
    }

    case RECEIVE_CUSTOM_FORMS: {
      action.payload.forEach((f) => {
        state = customFormsReducer(state, CustomFormActions.receiveCustomForm(f));
      });
      return state;
    }

    case RESET_CUSTOM_FORM: {
      const { customFormId } = action.payload;
      return reset(state, model, customFormId);
    }

    case UPDATE_CUSTOM_FORM_RJSF: {
      const { customFormId, formData: payloadFormData } = action.payload;
      const formData = cloneDeep(payloadFormData);

      // Remove fields without data
      for (const key of Object.keys(formData)) {
        if (formData[key] === null || formData[key] === undefined) {
          delete formData[key];
          continue;
        }

        if (typeof formData[key] === "string") {
          if (formData[key].trim() === "") {
            delete formData[key];
          }

          continue;
        }

        if (Array.isArray(formData[key]) && formData[key].length === 0) {
          delete formData[key];
        }
      }

      return state.setIn(["customForms", "byId", customFormId, "form_data"], fromJS(formData));
    }

    default:
      return state;
  }
};
